import { StrategicSourcingMetrics } from "./StrategicSourcingMetrics";

export default StrategicSourcingMetrics;
